import { render } from "./ScreenWrapper.vue?vue&type=template&id=ec3d4128&ts=true"
import script from "./ScreenWrapper.vue?vue&type=script&lang=ts"
export * from "./ScreenWrapper.vue?vue&type=script&lang=ts"

import "./ScreenWrapper.vue?vue&type=style&index=0&id=ec3d4128&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__